import { SentProposalStatus } from '@/ui/pages/proposalBuilderPage/components/sentProposalPanel/sentProposalStatus';
import { Badge } from '@payaca/ambrosia';
import { PrelineColourVariant } from '@payaca/types/preline';
import { FC } from 'react';

/** A Draft has no sent status, so it is the one state named here. */
export type ProposalStatus = 'draft' | SentProposalStatus;

type StatusPresentation = { label: string; colour: PrelineColourVariant };

/** Mirrors `EstimateStatusBadge`, so the two builders read the same. */
const STATUS_PRESENTATION: Record<ProposalStatus, StatusPresentation> = {
  draft: { label: 'Draft', colour: 'gray' },
  sent: { label: 'Sent', colour: 'blue' },
  bounced: { label: 'Bounced', colour: 'red' },
  accepted: { label: 'Accepted', colour: 'green' },
  declined: { label: 'Declined', colour: 'red' },
};

const ProposalStatusBadge: FC<{ status: ProposalStatus }> = (props) => {
  const { status } = props;
  const { label, colour } = STATUS_PRESENTATION[status];

  return (
    <Badge label="Status: " variant="soft" colour={colour}>
      {label}
    </Badge>
  );
};

export default ProposalStatusBadge;
